import { render } from "./Seafood.vue?vue&type=template&id=6d6b8d36"
import script from "./Seafood.vue?vue&type=script&lang=js"
export * from "./Seafood.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__